/* eslint-disable react-hooks/exhaustive-deps */

import { get, isEqual } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function useGetAllValuesUpdated(cardholerData: any) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const formValues = useSelector((state: any) => state?.state?.cardholderData);

  useEffect(() => {
    let preDisableBtn = true;
    if (!cardholerData?.errors?.length) {
      setBtnDisabled(false);
    } else {
      cardholerData?.errors?.forEach((item: any) => {
        const ArrOfpathFieldName = item?.stepsToFieldsMapping['cardholder.details'];
        ArrOfpathFieldName?.forEach((ele: any) => {
          const fieldDataBefore = get(cardholerData, ele?.split('.'));
          const fieldDataAfter = get(formValues, ele?.split('.'));
          if (!isEqual(fieldDataBefore, fieldDataAfter)) {
            preDisableBtn = false;
          }
        });
      });
      setBtnDisabled(preDisableBtn);
    }
  }, [JSON.stringify(formValues), cardholerData, formValues]);

  return btnDisabled;
}
export default useGetAllValuesUpdated;
